"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileSha = exports.pullRequestAndBranch = exports.pullRequests = exports.pullRequest = exports.repository = exports.openAuthoringBranches = exports.branch = exports.files = exports.statues = exports.blob = exports.user = exports.repoPermission = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _commonTags = require("common-tags");

var fragments = _interopRequireWildcard(require("./fragments"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject14() {
  const data = _taggedTemplateLiteral(["\n  query fileSha($owner: String!, $name: String!, $expression: String!) {\n    repository(owner: $owner, name: $name) {\n      ...RepositoryParts\n      file: object(expression: $expression) {\n        ...ObjectParts\n      }\n    }\n  }\n  ", "\n  ", "\n"]);

  _templateObject14 = function () {
    return data;
  };

  return data;
}

function _templateObject13() {
  const data = _taggedTemplateLiteral(["\n  query pullRequestAndBranch($owner: String!, $name: String!, $originRepoOwner: String!, $originRepoName: String!, $qualifiedName: String!, $number: Int!) {\n    repository(owner: $owner, name: $name) {\n      ...RepositoryParts\n      ", "\n    }\n    origin: repository(owner: $originRepoOwner, name: $originRepoName) {\n      ...RepositoryParts\n      ", "\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject13 = function () {
    return data;
  };

  return data;
}

function _templateObject12() {
  const data = _taggedTemplateLiteral(["\n  query pullRequests($owner: String!, $name: String!, $head: String, $states: [PullRequestState!]) {\n    repository(owner: $owner, name: $name) {\n      id\n      pullRequests(last: 100, headRefName: $head, states: $states) {\n        nodes {\n          ...PullRequestParts\n        }\n      }\n    }\n  }\n  ", "\n"]);

  _templateObject12 = function () {
    return data;
  };

  return data;
}

function _templateObject11() {
  const data = _taggedTemplateLiteral(["\n  query pullRequest($owner: String!, $name: String!, $number: Int!) {\n    repository(owner: $owner, name: $name) {\n      id\n      ", "\n    }\n  }\n  ", "\n"]);

  _templateObject11 = function () {
    return data;
  };

  return data;
}

function _templateObject10() {
  const data = _taggedTemplateLiteral(["\n  query repository($owner: String!, $name: String!) {\n    repository(owner: $owner, name: $name) {\n      ...RepositoryParts\n    }\n  }\n  ", "\n"]);

  _templateObject10 = function () {
    return data;
  };

  return data;
}

function _templateObject9() {
  const data = _taggedTemplateLiteral(["\n  query openAuthoringBranches($owner: String!, $name: String!, $refPrefix: String!) {\n    repository(owner: $owner, name: $name) {\n      ...RepositoryParts\n      refs(refPrefix: $refPrefix, last: 100) {\n        nodes {\n          ...BranchParts\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  const data = _taggedTemplateLiteral(["\n  query branch($owner: String!, $name: String!, $qualifiedName: String!) {\n    repository(owner: $owner, name: $name) {\n      ...RepositoryParts\n      ", "\n    }\n  }\n  ", "\n  ", "\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  const data = _taggedTemplateLiteral(["\n  query files($owner: String!, $name: String!, $expression: String!) {\n    repository(owner: $owner, name: $name) {\n      ...RepositoryParts\n      object(expression: $expression) {\n        ", "\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  const data = _taggedTemplateLiteral(["\n        object {\n          ... on Tree {\n            entries {\n              ...FileEntryParts\n              ", "\n            }\n          }\n        }\n    "]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  const data = _taggedTemplateLiteral(["\n    ...ObjectParts\n    ... on Tree {\n      entries {\n        ...FileEntryParts\n        ", "\n      }\n    }\n  "]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n  query statues($owner: String!, $name: String!, $sha: GitObjectID!) {\n    repository(owner: $owner, name: $name) {\n      ...RepositoryParts\n      object(oid: $sha) {\n        ...ObjectParts\n        ... on Commit {\n          status {\n            id\n            contexts {\n              id\n              context\n              state\n              target_url: targetUrl\n            }\n          }\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n  query blob($owner: String!, $name: String!, $expression: String!) {\n    repository(owner: $owner, name: $name) {\n      ...RepositoryParts\n      object(expression: $expression) {\n        ... on Blob {\n          ...BlobWithTextParts\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n  query {\n    viewer {\n      id\n      avatar_url: avatarUrl\n      name\n      login\n    }\n  }\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n  query repoPermission($owner: String!, $name: String!) {\n    repository(owner: $owner, name: $name) {\n      ...RepositoryParts\n      viewerPermission\n    }\n  }\n  ", "\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const repoPermission = (0, _graphqlTag.default)(_templateObject(), fragments.repository);
exports.repoPermission = repoPermission;
const user = (0, _graphqlTag.default)(_templateObject2());
exports.user = user;
const blob = (0, _graphqlTag.default)(_templateObject3(), fragments.repository, fragments.blobWithText);
exports.blob = blob;
const statues = (0, _graphqlTag.default)(_templateObject4(), fragments.repository, fragments.object);
exports.statues = statues;

const buildFilesQuery = (depth = 1) => {
  const PLACE_HOLDER = 'PLACE_HOLDER';
  let query = (0, _commonTags.oneLine)(_templateObject5(), PLACE_HOLDER);

  for (let i = 0; i < depth - 1; i++) {
    query = query.replace(PLACE_HOLDER, (0, _commonTags.oneLine)(_templateObject6(), PLACE_HOLDER));
  }

  query = query.replace(PLACE_HOLDER, '');
  return query;
};

const files = depth => (0, _graphqlTag.default)(_templateObject7(), buildFilesQuery(depth), fragments.repository, fragments.object, fragments.fileEntry);

exports.files = files;
const branchQueryPart = "\nbranch: ref(qualifiedName: $qualifiedName) {\n  ...BranchParts\n}\n";
const branch = (0, _graphqlTag.default)(_templateObject8(), branchQueryPart, fragments.repository, fragments.branch);
exports.branch = branch;
const openAuthoringBranches = (0, _graphqlTag.default)(_templateObject9(), fragments.repository, fragments.branch);
exports.openAuthoringBranches = openAuthoringBranches;
const repository = (0, _graphqlTag.default)(_templateObject10(), fragments.repository);
exports.repository = repository;
const pullRequestQueryPart = "\npullRequest(number: $number) {\n  ...PullRequestParts\n}\n";
const pullRequest = (0, _graphqlTag.default)(_templateObject11(), pullRequestQueryPart, fragments.pullRequest);
exports.pullRequest = pullRequest;
const pullRequests = (0, _graphqlTag.default)(_templateObject12(), fragments.pullRequest);
exports.pullRequests = pullRequests;
const pullRequestAndBranch = (0, _graphqlTag.default)(_templateObject13(), branchQueryPart, pullRequestQueryPart, fragments.repository, fragments.branch, fragments.pullRequest);
exports.pullRequestAndBranch = pullRequestAndBranch;
const fileSha = (0, _graphqlTag.default)(_templateObject14(), fragments.repository, fragments.object);
exports.fileSha = fileSha;